import { Modal, ModalBody } from 'reactstrap';
import CloudStorage from '../../../CloudStorage/CloudStorage';

export default function DisputeResponseModal({ modal, setModal }) {

  return (
    <Modal
      className="popupmodal logout"
      isOpen={modal}
      toggle={() => setModal(false)}
      style={{width:'90%'}}
    >
      <button
        onClick={() => setModal((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody style={{width:'100%'}}>
        <br />
        <h4 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '15px', color: '#333' }}>
          Your Dispute Has Been Submitted!
        </h4>
        <br />
        <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#555' }}>
          Thank you for reaching out to us. We have successfully received your dispute and want to assure you that your concerns are being taken seriously.
          Our dedicated team will carefully review all the details you provided to ensure that the issue is fully understood and addressed appropriately.
          The review process may take some time depending on the complexity of the dispute, but rest assured, we prioritize fairness and accuracy in every case.
          While we evaluate your submission, you can provide any additional information or supporting documents that may help us assess your situation more efficiently.
          We will keep you informed and provide updates as soon as a resolution has been reached. Your patience and cooperation are greatly appreciated,
          and we are committed to resolving your dispute as quickly and fairly as possible. Thank you for trusting us to handle this matter with care.
        </p>
      </ModalBody>

    </Modal>
  )
}